import React, { lazy, Suspense, useEffect } from "react";
import classes from "./mainRoute.module.css";
import Header from "../../components/Header";
import { Route, Routes, useSearchParams } from "react-router-dom";
import useScrollTop from "../../hooks/useScrollTop";
import Privacy from "../../features/Privacy";
import AboutPage from "../../features/AboutPage";
import AccountDelete from "../../features/AccountDelete";
import { toast } from "react-toastify";
import SubjectFormModal from "../../features/FileDetail/SubjectFormModal";
import PracticeReview from "../../features/PracticeReview";
import LoadingFallBack from "../../components/LoadingFallback";
import AffiliateInterstitial from "../../components/AffiliateInterstitial";

const Home = lazy(() => import("../../features/Home"));
const Footer = lazy(() => import("../../components/Footer"));
const FileDetail = lazy(() => import("../../features/FileDetail"));
const LoginRegister = lazy(
  () => import("../../features/Authentication/authentication")
);
const FileList = lazy(() => import("../../features/FileList"));
const FileForm = lazy(() => import("../../features/FileForm/FileForm"));
const FileSearch = lazy(() => import("../../features/FileSearch"));
const CalcPoint = lazy(() => import("../../features/CalcPoint"));
const NotFound = lazy(() => import("../../features/NotFound"));
const Convert10To4 = lazy(() => import("../../features/Convert10To4"));
const PracticeHome = lazy(() => import("../../features/PracticeHome"));
const PracticeControl = lazy(() => import("../../features/PracticeControl"));
const PracticeHistory = lazy(() => import("../../features/PracticeHistory"));
const BlogList = lazy(() => import("../../features/BlogList"));
const BlogDetail = lazy(() => import("../../features/BlogDetail"));
const Notes = lazy(() => import("../../features/Notes"));
const StudentGear = lazy(() => import("../../features/StudentGear"));

function MainRoute() {
  useScrollTop();
  const [searchParams] = useSearchParams();

  useEffect(() => {
    const type = searchParams.get("type");
    const message = searchParams.get("message");
    if ((message && type === "info") || type === "error") {
      toast[type](message);
    }
  }, [searchParams]);

  return (
    <Suspense fallback={<LoadingFallBack />}>
      <Header />
      <div className={classes.content}>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/file-view" element={<FileDetail />} />
          <Route
            path="/gpa-cpa-learning-plan"
            element={<FileDetail localScreen={true} />}
          />
          <Route path="/about" element={<AboutPage />} />
          <Route path="/login" element={<LoginRegister />} />
          <Route path="/register" element={<LoginRegister />} />
          <Route path="/file-list" element={<FileList />} />
          <Route path="/create-file" element={<FileForm />} />
          <Route path="/update-file/:id" element={<FileForm />} />
          <Route path="/create-root-file" element={<FileForm />} />
          <Route path="/update-root-file/:id" element={<FileForm />} />
          <Route path={"/find-file"} element={<FileSearch />} />
          <Route path={"/calc-point"} element={<CalcPoint />} />
          <Route path={"/privacy"} element={<Privacy />} />
          <Route path={"/delete-account"} element={<AccountDelete />} />
          <Route path={"/convert-10-to-4"} element={<Convert10To4 />} />
          <Route path={"/practice-home"} element={<PracticeHome />} />
          <Route path={"/practice-review"} element={<PracticeReview />} />
          <Route path={"/practice-control"} element={<PracticeControl />} />
          <Route path={"/practice-history"} element={<PracticeHistory />} />
          <Route path={"/blog"} element={<BlogList />} />
          <Route path={"/blog/:slug"} element={<BlogDetail />} />
          <Route path={"/notes"} element={<Notes />} />
          <Route path={"/do-dung-sinh-vien"} element={<StudentGear />} />
          <Route path={"*"} element={<NotFound />} />
        </Routes>
      </div>
      <Footer />
      <SubjectFormModal />
      <AffiliateInterstitial />
    </Suspense>
  );
}

export default MainRoute;
